<template>
  <v-container fluid justify-start>

    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="filteredPurges"
      :loading="isLoading"
      :search="search"
      :no-data-text="noDataText"
      item-key="id"
      class="elevation-2"
      >

      <v-progress-linear slot="progress" :color="appColor_Progress" indeterminate />

      <template v-slot:top>
        <!-- Header Toolbar -->
        <v-toolbar dense dark flat :color="appColor_Medium">
          
          <app-back-button v-bind:color="appColor_Dark" />

          <v-toolbar-title>Message Purges</v-toolbar-title>

        </v-toolbar>

        <!-- Filters -->
        <v-row no-gutters class="mx-3 mt-2">

          <!-- Search -->
          <v-col cols="12" md="12">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              :disabled="isLoading"
              clearable
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.id="{ item }">
        <span class="text-left">
          <span v-if="item.numMessages > 0" @click="showDetail(item)">
            <span :style="appStyle_HyperLink">{{ item.id }}</span>
          </span>
          <span v-else>{{ item.id }}</span>
        </span>
      </template>

      <template v-slot:item.datePurged="{ item }">
        <span class="text-left"><app-date :date="item.datePurged" /></span>
      </template>

    </v-data-table>

    <v-dialog v-model="detailDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <message-purge-detail
        v-bind:messagePurgeId="selectedId"
        v-bind:datePurged="datePurged"
        v-on:close="detailDialog = false"
      />
    </v-dialog>

  </v-container>
</template>

<script>
import appService from '@/app.service.js'
import { AppColor, AppStyle } from '@/config.js'
import AppDate from '@/components/App/AppDate'
import AppBackButton from '@/components/App/AppBackButton'
import MessagePurgeDetail from '@/components/MessagePurgeDetail'

export default {
  name: 'MessagePurges',
  components: {
    AppDate,
    MessagePurgeDetail,
    AppBackButton
  },
  data() {
    return {
      // colors
      appColor_Medium: AppColor.Medium,
      appColor_Dark: AppColor.Dark,
      appColor_Progress: AppColor.Progress,

      // styles
      appStyle_HyperLink: AppStyle.HyperLink,

      isLoading: true,
      search: '',
      selectedId: null,
      datePurged: null,
      detailDialog: false,

      headers: [
        {
          text: 'Id',
          value: 'id',
          align: 'left',
          width: '10%',
          class: 'pr-0'
        },
        {
          text: 'Date Purged',
          value: 'datePurged',
          align: 'left',
          width: '60%',
          class: 'pr-0'
        },
        {
          text: 'Messages',
          value: 'numMessages',
          align: 'left',
          width: '10%',
          class: 'pr-0'
        },
        {
          text: 'Warnings',
          value: 'numWarnings',
          align: 'left',
          width: '10%'
        },        
        {
          text: 'Errors',
          value: 'numErrors',
          align: 'left',
          width: '10%',
          class: 'pr-0'
        }
      ],
      messagePurges: []
    }
  },
  computed: {
    noDataText () {
      if (this.isLoading) return 'One moment...'

      return this.messagePurges.length === 0
        ? 'No message purges found'
        : ''
    },
    filteredPurges () {
      if (this.messagePurges === null) return []

      const self = this

      return self.messagePurges.filter(p => {
        return (
          p.id > 0
        )
      })
    }
  },
  methods: {
    loadData () {
      const self = this
      self.isLoading = true
      appService.getMessagePurges().then(data => {
        if (data.errorSeverity > 0) {
          self.handleError(data)
        } else {
          self.messagePurges = data.messagePurges
        }
        self.isLoading = false
      }).catch(e => { self.handleCriticalError(e) })
    },

    showDetail (item) {
      if (item.id <= 0) return
      this.selectedId = item.id
      this.datePurged = item.datePurged
      this.detailDialog = true
    },

    handleError (result) {
      this.$error.show({
        title:
          result.errorSeverity === 0 ? 'Validation Failed' : 'Internal Error',
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  created() {
    this.loadData()
  }
}
</script>
